/**
 * React Query hooks for tasks module settings
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { workManagementSettingsApi, type WorkManagementTenantSettingsUpdate } from '../services/workManagementSettingsApi';

const TENANT_SETTINGS_QUERY_KEY = ['tasks-tenant-settings'];
const USER_SETTINGS_QUERY_KEY = ['tasks-user-settings'];

// ========== Tenant Settings (Admin) ==========

export function useWorkManagementTenantSettings() {
  return useQuery({
    queryKey: TENANT_SETTINGS_QUERY_KEY,
    queryFn: workManagementSettingsApi.getTenantSettings,
  });
}

export function useUpdateWorkManagementTenantSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: WorkManagementTenantSettingsUpdate) =>
      workManagementSettingsApi.updateTenantSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANT_SETTINGS_QUERY_KEY });
    },
  });
}

// ========== User Settings ==========

export function useWorkManagementUserSettings() {
  return useQuery({
    queryKey: USER_SETTINGS_QUERY_KEY,
    queryFn: workManagementSettingsApi.getUserSettings,
  });
}

export function useUpdateWorkManagementUserSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: workManagementSettingsApi.updateUserSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_SETTINGS_QUERY_KEY });
    },
  });
}
